import { FC } from 'react';
import { Message } from 'types';
//@ts-ignore
import Twemoji from 'react-twemoji';
import Tippy from '@tippyjs/react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

const Reactions: FC<{
    message: Message;
    selectReaction: any;
}> = ({ message, selectReaction }) => {

    const removeReaction = async (emojiId: string) => {
        const response = await fetch(`__SITE_BASE__/api/v1/channels/${message.channelId}/messages/${message.id}/reactions/${emojiId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            console.error('Failed to remove reaction');
        }
    };
    const { teamId } = useParams();
    const queryClient = useQueryClient();
    const members = (queryClient.getQueryState(["teams", teamId, "members"]) as any);
    const me = (queryClient.getQueryData(["user"]) as any).user;
    return (
        <>
            {message.reactions?.length > 0 && (
                <div className="flex flex-wrap items-center gap-1 mt-2 max-w-[80rem]">
                    {message.reactions?.map((reaction) => {
                        const userReacted = reaction.users.some(user => user?.id === me?.id);
                        const reactedUsersText = reaction.users
                            .slice(0, 3)
                            .map(user => members?.data?.members.find((member: any) => member?.id === user?.id)?.username || 'Unknown User')
                            .join(', ');
                        const othersCount = reaction.users.length - 3;
                        const othersText = othersCount > 0 ? ` and ${othersCount} others` : '';

                        return (
                            <Tippy content={
                                reaction.users.length > 0
                                    ? `${reactedUsersText}${othersText} reacted`
                                    : 'React'
                            } key={reaction.emojiId} placement="top" interactive={true}>
                                <div
                                    onClick={() => {
                                        if (userReacted) {
                                            removeReaction(reaction.emojiId);
                                        } else {
                                            selectReaction({
                                                id: reaction.emojiId,
                                            });
                                        }
                                    }}
                                    key={reaction.emojiId}
                                    className={`flex items-start space-x-1 break-all rounded-full px-4 py-1 cursor-pointer transition-all duration-300 ${userReacted ? 'bg-brand-green/75 hover:bg-brand-green border-brand-back border-2' : 'bg-brand-default hover:bg-brand-dark/75'}`}
                                >
                                    {reaction.emojiId.length > 8 ? (
                                        <img
                                            src={`${import.meta.env.VITE_BUCKET_URL}emojis/${reaction.emojiId}.webp`}
                                            className="w-5"
                                            alt="emoji"
                                        />
                                    ) : (
                                        <Twemoji options={{ className: 'h-5 w-5' }}>
                                            {reaction.emojiId}
                                        </Twemoji>
                                    )}
                                    <span className="text-sm font-semibold break-all">{reaction.count}</span>
                                </div>
                            </Tippy>
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default Reactions;
